import { render, staticRenderFns } from "./transfers.vue?vue&type=template&id=7f31af24&"
import script from "./transfers.vue?vue&type=script&lang=js&"
export * from "./transfers.vue?vue&type=script&lang=js&"
import style0 from "./transfers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports